import React, { useState, useEffect } from 'react';
import { ExternalLink } from 'lucide-react';
import { supabase } from '../../lib/supabase';

interface Ad {
  id: string;
  title: string;
  body: string | null;
  image_url: string | null;
  cta_label: string | null;
  cta_url: string | null;
}

export function AdsSection() {
  const [ads, setAds] = useState<Ad[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase
      .from('ads')
      .select('id, title, body, image_url, cta_label, cta_url')
      .order('display_order', { ascending: true })
      .limit(3)
      .then(({ data }) => {
        setAds(data ?? []);
        setLoading(false);
      });
  }, []);

  if (loading || ads.length === 0) return null;

  return (
    <div className="space-y-3">
      {ads.map((ad) => (
        <div
          key={ad.id}
          className="bg-white dark:bg-charcoal rounded-lg shadow-sm border border-sand/20 dark:border-slate/20 overflow-hidden"
        >
          {ad.image_url && (
            <img
              src={ad.image_url}
              alt={ad.title}
              className="w-full object-cover max-h-36"
              onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
            />
          )}
          <div className="p-4">
            <p className="text-sm font-semibold text-midnight dark:text-soft-white">{ad.title}</p>
            {ad.body && (
              <p className="text-xs text-slate dark:text-soft-white/60 mt-1 leading-relaxed">{ad.body}</p>
            )}
            {ad.cta_url && ad.cta_label && (
              <a
                href={ad.cta_url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-md bg-gradient-to-r from-gold to-fiery text-white hover:opacity-90 transition-opacity"
              >
                {ad.cta_label}
                <ExternalLink className="h-3 w-3" />
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
